import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=2d206a20"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d206a20')) {
      api.createRecord('2d206a20', component.options)
    } else {
      api.reload('2d206a20', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=2d206a20", function () {
      api.rerender('2d206a20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/datasourceconfig/edit.vue"
export default component.exports